import { render, staticRenderFns } from "./ReaderInfo.vue?vue&type=template&id=0d94f3de&scoped=true&"
import script from "./ReaderInfo.vue?vue&type=script&lang=js&"
export * from "./ReaderInfo.vue?vue&type=script&lang=js&"
import style0 from "./ReaderInfo.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ReaderInfo.vue?vue&type=style&index=1&id=0d94f3de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d94f3de",
  null
  
)

export default component.exports